export default function DriverDocumentRow({ doc, onUpload, onView }) {
  return (
    <div className="docRowCompact">
      {/* NOM */}

      <div className="docCol name">{doc.name}</div>

      {/* STATUT */}
      <div className="docCol status">
        {doc.uploaded ? (
          <span className="badge green">
            ✔ {doc.isMultiple ? `${doc.files.length} fichiers` : "Fourni"}
          </span>
        ) : (
          <span className="badge red">✖ Manquant</span>
        )}
      </div>

      {/* TYPE */}
      <div className="docCol meta">
        {doc.isRequired ? "Requis" : "Optionnel"} •{" "}
        {doc.isMultiple ? "Multiple" : "Unique"}
      </div>

      {/* ACTION */}
      <div className="docCol actions">
    
        {doc.uploaded && (
          <button className="btnGhost small" onClick={() => onView(doc.files)}>
            Voir ({doc.files.length})
          </button>
        )}

        {(!doc.uploaded || doc.isMultiple) && (
          <button className="btnPrimary small" onClick={() => onUpload(doc)}>
            {doc.uploaded ? "Ajouter" : "Uploader"}
          </button>
        )}
      </div>
    </div>
  );
}
